import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    padding: 30,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    maxWidth: 450,
  },
  menu: {
    maxWidth: 450,
  },
});

const SignRiderOptions = props => {
  const { classes, handleChange, shippingAddress } = props;

  return (
    <form className={classes.container} noValidate autoComplete="off">
      <FormLabel className={classes.label}>Shipping Address.</FormLabel>
      <FormHelperText className={classes.helperText}>
        You can modify shipping address here.
      </FormHelperText>
      <TextField
        id="shipping-address-name"
        label="Name"
        className={classes.textField}
        value={shippingAddress.name}
        onChange={event => {
          handleChange('shippingAddress', {
            ...shippingAddress,
            name: event.target.value,
          });
        }}
        margin="normal"
      />
      <TextField
        id="shipping-address-line1"
        label="Address line1"
        className={classes.textField}
        value={shippingAddress.line1}
        onChange={event => {
          handleChange('shippingAddress', {
            ...shippingAddress,
            line1: event.target.value,
          });
        }}
        margin="normal"
      />
      <TextField
        id="shipping-address-line2"
        label="Address line2"
        className={classes.textField}
        value={shippingAddress.line2 || ''}
        onChange={event => {
          handleChange('shippingAddress', {
            ...shippingAddress,
            line2: event.target.value,
          });
        }}
        margin="normal"
      />
      <TextField
        id="shipping-address-city"
        label="City"
        className={classes.textField}
        value={shippingAddress.city}
        onChange={event => {
          handleChange('shippingAddress', {
            ...shippingAddress,
            city: event.target.value,
          });
        }}
        margin="normal"
      />
      <TextField
        id="shipping-address-state"
        label="State"
        className={classes.textField}
        value={shippingAddress.state}
        onChange={event => {
          handleChange('shippingAddress', {
            ...shippingAddress,
            state: event.target.value,
          });
        }}
        margin="normal"
      />
      <TextField
        id="shipping-address-zip"
        label="Zip"
        className={classes.textField}
        value={shippingAddress.zip}
        onChange={event => {
          handleChange('shippingAddress', {
            ...shippingAddress,
            zip: event.target.value,
          });
        }}
        margin="normal"
      />
    </form>
  );
};

export default withStyles(styles)(SignRiderOptions);



// WEBPACK FOOTER //
// ./src/components/SignRiderShipping.js